/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_KickerInputs */

const en_map_kicker = /** @type {(inputs: Map_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The map`)
};

/**
* | output |
* | --- |
* | "The map" |
*
* @param {Map_KickerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const map_kicker = /** @type {((inputs?: Map_KickerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_KickerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_map_kicker(inputs)
});